// components/layout/Footer.jsx
import React from 'react';
import '../../styles/footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <h3>CollegeAggregator</h3>
          <p>Helping students discover the right colleges with transparent data on courses, fees, and placements.</p>
        </div>

       

          <div className="footer-col">
            <h4>Contact</h4>
            <p>Email: collegeaggregator@gmail.com</p>
            <p>Mobile : +91 81265 35439</p>
            <p>24 x 7 Support</p>
            <div className="footer-social">
              <a
                href="https://www.facebook.com/collegeaggregator?mibextid=ZbWKwL"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                FB
              </a>
              <a
                href="https://instagram.com/collegeaggregator?igshid=ZDdkNTZiNTM="
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                IG
              </a>
              <a
                href="https://www.linkedin.com/company/collegeaggregator/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
              >
                in
              </a>
              <a
                href="https://g.co/kgs/7wKFni"
                target="_blank"
                rel="noreferrer"
                aria-label="Google"
              >
                G
              </a>
            </div>
          </div>
        </div>
      

      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} CollegeAggregator. All rights reserved.</span>
        <div className="footer-links">
          <a href="#terms">Terms</a>
          <a href="#privacy">Privacy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
